import styled from 'styled-components';

import { theme } from '../layout/theme';
import { fadeIn } from '../layout/keyframes';

type BackdropProperties = {
  transparent?: boolean;
};

export const Backdrop = styled.div<BackdropProperties>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${theme.layers.belowBackdrop};
  background: ${(props: BackdropProperties) => (props.transparent ? 'none' : 'rgba(0, 0, 0, 0.1)')};
  animation: ${fadeIn} 125ms linear;
`;
